export type LocalKeyType =
  | "saveEmail"
  | "BIO"
  | "bioUser"
  | "boarded"
  | "AUTO"
  | "recentCategory"
  | "recentLocation"
  | "rentalManagerStore"
  | "talkMenuStore"
  | "jwtToken";

export const getLocalValue = (key: LocalKeyType) => {
  return window.localStorage.getItem(key);
};

export const setLocalValue = (key: LocalKeyType, value: string) => {
  return window.localStorage.setItem(key, value);
};

export const removeLocalValue = (key: LocalKeyType) => {
  if (key === "jwtToken") {
    window.dispatchEvent(new Event("tokenRemove"));
  }

  return window.localStorage.removeItem(key);
};

export const addLocalArrayValue = (
  key: LocalKeyType,
  keyField: string,
  object: any
) => {
  const prevList = JSON.parse(getLocalValue(key) ?? "[]");
  if (prevList.find((item: any) => item[keyField] === object[keyField])) {
    setLocalValue(
      key,
      JSON.stringify(
        JSON.parse(getLocalValue(key) ?? "[]").map((item: any) =>
          item[keyField] === object[keyField] ? object : item
        )
      )
    );
  } else {
    setLocalValue(
      key,
      JSON.stringify([...JSON.parse(getLocalValue(key) ?? "[]"), object])
    );
  }
};

export const getLocalArrayValue = (
  key: LocalKeyType,
  keyField: string,
  targetValue?: string
) => {
  if (!targetValue) return null;
  const prevList = JSON.parse(getLocalValue(key) ?? "[]");
  const prev = prevList.find((prev: any) => prev[keyField] === targetValue);
  return prev;
};
